import React, { useState } from 'react';
import { HelpCircleIcon } from 'lucide-react';
interface FaqItemData {
  question: string;
  answer: React.ReactNode;
}
const faqItems: FaqItemData[] = [{
  question: '¿Cómo accedo al material?',
  answer: <p data-id="element-122">
        Una vez que realices el pago, recibirás un correo electrónico con un
        enlace de acceso inmediato a nuestra plataforma privada. Desde allí
        podrás descargar la guía, los simuladores y todos los bonos a tu
        computadora, tablet o celular para verlos cuando quieras, incluso sin
        conexión a internet.
      </p>
}, {
  question: '¿Es un pago mensual o un pago único?',
  answer: <p data-id="element-123">
        Es un pago único. No hay suscripciones, ni mensualidades ocultas, ni
        cargos sorpresa. Pagas una sola vez y tienes acceso de por vida a todo
        el material, incluyendo todas las futuras actualizaciones que hagamos al
        sistema sin costo adicional.
      </p>
}, {
  question: '¿Sirve si no tengo experiencia previa?',
  answer: <p data-id="element-124">
        ¡Absolutamente! El sistema está diseñado desde cero, explicando cada
        componente y circuito paso a paso con diagramas visuales muy fáciles de
        entender. No necesitas ser un experto ni tener conocimientos avanzados
        de ingeniería para empezar a montar tus propios tableros de control.
      </p>
}, {
  question: '¿Es pura teoría o es práctico?',
  answer: <p data-id="element-125">
        Nuestra guía es 100% práctica. Hemos eliminado toda la teoría
        innecesaria que enseñan en las escuelas tradicionales y nos enfocamos
        directamente en lo que necesitas saber para trabajar en el mundo real.
        Aprenderás viendo diagramas reales y aplicando el conocimiento en el
        simulador antes de tocar un cable.
      </p>
}, {
  question: '¿Tengo acceso de por vida?',
  answer: <p data-id="element-126">
        Sí, tu acceso no caduca nunca. Podrás entrar a la plataforma y descargar
        el material hoy, mañana o dentro de 5 años. Además, cada vez que
        agreguemos nuevos diagramas, ejercicios o herramientas al sistema,
        tendrás acceso a ellos completamente gratis.
      </p>
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(prev => prev === index ? null : index);
  };
  return <section className="bg-cream py-10 px-4" data-id="element-127">
      <div className="max-w-[600px] mx-auto" data-id="element-128">
        <h2 className="text-[26px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-129">
          <HelpCircleIcon className="w-6 h-6 text-primary" data-id="element-130" />
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3" data-id="element-131">
          {faqItems.map((item, index) => <div key={index} className="rounded-lg overflow-hidden shadow-sm border border-white/10 bg-brand-black-light" data-id="element-132">
              <button onClick={() => toggleFaq(index)} className="w-full p-4 font-semibold text-base cursor-pointer flex justify-between items-center text-left bg-transparent border-none text-brand-black hover:bg-white/5 transition-colors" aria-expanded={openIndex === index} data-id="element-133">
                <span data-id="element-134">{item.question}</span>
                <span className="text-[22px] text-primary transition-transform duration-300 flex-shrink-0 ml-2" data-id="element-135">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className="overflow-hidden transition-[max-height] duration-300 ease-out" style={{
            maxHeight: openIndex === index ? '200px' : '0px'
          }} data-id="element-136">
                <div className="px-4 pb-4 pt-0 text-sm text-dark-gray leading-relaxed border-t border-white/5" data-id="element-137">
                  <div className="pt-4" data-id="element-138">{item.answer}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}